import ActivityHeatmap from "../ActivityHeatmap/ActivityHeatmap";
import AllTimeStatsStrip from "../AllTimeStatsStrip";
import {
  ActivityHeatmapDay,
  AllTimeStudentStats,
  PlatformStreakStats,
} from "../../constants/dashboardStats";
import "./AllTimeStatsSection.scss";

type AllTimeStatsSectionProps = {
  stats: AllTimeStudentStats;
  heatmapDays: ActivityHeatmapDay[];
  platformStreak?: PlatformStreakStats;
};

const AllTimeStatsSection = ({
  stats,
  heatmapDays,
  platformStreak,
}: AllTimeStatsSectionProps) => (
  <>
    <div className="all-time-stats-section__header">All-time stats</div>
    <AllTimeStatsStrip stats={stats} platformStreak={platformStreak} />
    <ActivityHeatmap days={heatmapDays} />
  </>
);

export default AllTimeStatsSection;
